module.exports = __webpack_public_path__ + "img/bg_main_t_r_1.f2b1eff5.png";